import React, {Component} from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import {Icon, Modal, Popover, Tooltip, Spin} from 'antd'
import UpdateDesign from '../../actions/UpdateDesign'
import {Typography} from 'antd'
import { getLocalData, setLocalData } from '../../../../../../services/StorageServices'
import LazyLoad from 'react-lazyload'

const {Paragraph} = Typography

class ItemSideImage extends Component {
    state = {
        loaded: false,
        popover: false,
        modal: false,
        disableMockup: this.props.side === 'front' ? getLocalData('ImageFrontDisable') ? getLocalData('ImageFrontDisable') : [] : getLocalData('ImageBackDisable') ? getLocalData('ImageBackDisable') : []
    }

    _hide = () => {
        this.setState({
            popover: false,
        })
    }

    _handlePopoverChange = popover => {
        this.setState({popover})
    }

    _showModal = () => {
        this.setState({
            modal: true,
        })
    }

    _hideModal = () => {
        this.setState({
            modal: false,
        })
    }

    _handleDisableImageMockup = () => {
        const {side, orderId} = this.props
        const disableStorage = side === 'front' ? getLocalData('ImageFrontDisable') ? getLocalData('ImageFrontDisable') : [] : getLocalData('ImageBackDisable') ? getLocalData('ImageBackDisable') : []

        const arrDisable = [...disableStorage]
        arrDisable.push(orderId)

        if(side === 'front'){
            setLocalData('ImageFrontDisable', arrDisable)
        }else{
            setLocalData('ImageBackDisable', arrDisable)
        }
        

        this.setState({
            disableMockup: arrDisable
        })
    }

    _handleEnableImageMockup = () => {
        const {side, orderId} = this.props
        const disableStorage = side === 'front' ? getLocalData('ImageFrontDisable') ? getLocalData('ImageFrontDisable') : [] : getLocalData('ImageBackDisable') ? getLocalData('ImageBackDisable') : []

        const arrDisable = [...disableStorage].filter(item => item !== orderId)
        if(side === 'front'){
            setLocalData('ImageFrontDisable', arrDisable)
        }else{
            setLocalData('ImageBackDisable', arrDisable)
        }

        this.setState({
            disableMockup: arrDisable
        })
    }

    render() {
        const {side, url, tagFalseDesign, orderId} = this.props
        const {popover, modal, disableMockup} = this.state

        return (
            <div className={className('ItemSideImage', {'hasPreview': url, 'srcEditing': popover})}>
                <div className='Preview position-relative bg-light'>
                    
                    {
                        url && disableMockup.indexOf(orderId) === -1 &&
                        <LazyLoad>
                            <img src={url} alt='preview' className='position-absolute'/>
                        </LazyLoad>
                    }

                    <span className='Side position-absolute'><span className='badge bg-white'>{side}</span></span>

                    <div className='Actions position-absolute'>
                        <Popover popover={popover} title='Edit url' trigger='click' placement='bottom'
                                 content={<UpdateDesign {...this.props} onSuccess={this._hide}/>}
                                 onVisibleChange={this._handlePopoverChange}>
                            <span className={`Icon ${tagFalseDesign ? 'FalseDesignAction' : ''}`}><Icon
                                type="edit"/></span>
                        </Popover>

                        {
                            url && disableMockup.indexOf(orderId) === -1 &&
                            <>
                                <div className={`Icon ${tagFalseDesign ? 'FalseDesignAction' : ''}`}>
                                    {/* <Icon type="eye" onClick={this._showModal}/> */}
                                    <Tooltip title="Disable mockup">
                                        {/* <Icon type="eye-invisible" onClick={this._handleDisableImageMockup}/> */}
                                        <span onClick={this._handleDisableImageMockup}>
                                            <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.2647 15.9377L12.5473 14.2346C11.758 13.4519 11.3633 13.0605 10.9089 12.9137C10.5092 12.7845 10.079 12.7845 9.67922 12.9137C9.22485 13.0605 8.83017 13.4519 8.04082 14.2346L4.04193 18.2622M14.2647 15.9377L14.606 15.5991C15.412 14.7999 15.8149 14.4003 16.2773 14.2545C16.6839 14.1262 17.1208 14.1312 17.5244 14.2688C17.9832 14.4253 18.3769 14.834 19.1642 15.6515L20 16.5001M14.2647 15.9377L18.22 19.9628M12 4H7.2C6.07989 4 5.51984 4 5.09202 4.21799C4.7157 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.0799 4 7.2V16.8C4 17.4466 4 17.9066 4.04193 18.2622M4.04193 18.2622C4.07264 18.5226 4.12583 18.7271 4.21799 18.908C4.40973 19.2843 4.7157 19.5903 5.09202 19.782C5.51984 20 6.07989 20 7.2 20H16.8C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V12M16 3L18.5 5.5M18.5 5.5L21 8M18.5 5.5L21 3M18.5 5.5L16 8" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </Tooltip>
                                </div>
                            </>
                        }

                        {
                            url && disableMockup.indexOf(orderId) !== -1 &&
                            <>
                                <div className={`Icon ${tagFalseDesign ? 'FalseDesignAction' : ''}`}>
                                    <Tooltip title="Enable mockup">
                                        {/* <Icon type="eye" onClick={this._handleEnableImageMockup}/> */}
                                        <span onClick={this._handleEnableImageMockup}>
                                            <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.2647 15.9377L12.5473 14.2346C11.758 13.4519 11.3633 13.0605 10.9089 12.9137C10.5092 12.7845 10.079 12.7845 9.67922 12.9137C9.22485 13.0605 8.83017 13.4519 8.04082 14.2346L4.04193 18.2622M14.2647 15.9377L14.606 15.5991C15.412 14.7999 15.8149 14.4003 16.2773 14.2545C16.6839 14.1262 17.1208 14.1312 17.5244 14.2688C17.9832 14.4253 18.3769 14.834 19.1642 15.6515L20 16.5001M14.2647 15.9377L18.22 19.9628M11 4H7.2C6.07989 4 5.51984 4 5.09202 4.21799C4.7157 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.0799 4 7.2V16.8C4 17.4466 4 17.9066 4.04193 18.2622M4.04193 18.2622C4.07264 18.5226 4.12583 18.7271 4.21799 18.908C4.40973 19.2843 4.7157 19.5903 5.09202 19.782C5.51984 20 6.07989 20 7.2 20H16.8C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V13M15 5.28571L16.8 7L21 3" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </Tooltip>
                                </div>
                            </>
                        }

                        {
                            url && disableMockup.indexOf(orderId) === -1 &&
                            <>
                                <div className={`Icon ${tagFalseDesign ? 'FalseDesignAction' : ''}`}>
                                    {/* <Icon type="eye" onClick={this._showModal}/>
                                    <Icon type="eye-invisible" onClick={this._showModal}/> */}
                                    <Tooltip title="View Image">
                                        <Icon type="eye" onClick={this._showModal}/>
                                    </Tooltip>

                                    <Modal visible={modal} closable={false} centered={true} footer={null} width={1000}
                                           onCancel={this._hideModal}>
                                        <img src={url} alt='full' className='d-block m-auto'/>
                                    </Modal>
                                </div>
                                <span className='Icon'><Paragraph copyable={{text: url}} className='mb-0'/></span>
                            </>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

ItemSideImage.defaultProps = {
    url: '',
}

ItemSideImage.propTypes = {
    side: PropTypes.string.isRequired,
    url: PropTypes.string,
    orderId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['update-design', 'update-mock-up']),
}

export default ItemSideImage
